import { render, staticRenderFns } from "./templateTabs.vue?vue&type=template&id=0b7ecf02&scoped=true&"
import script from "./templateTabs.vue?vue&type=script&lang=js&"
export * from "./templateTabs.vue?vue&type=script&lang=js&"
import style0 from "./templateTabs.vue?vue&type=style&index=0&id=0b7ecf02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ecf02",
  null
  
)

export default component.exports